/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/UserHomeIntro.tsx.
 */

import React from "react";
import "../UserHome.css";

const UserHomeIntro: React.FC = () => {
  return (
    <div className="user-home-intro">
      <h1 className="user-home-title">
        Indian Construction Materials Embodied Carbon Database
      </h1>
      <p className="user-home-description">
        ICOMEC is a decision-support tool designed to help architects, engineers, researchers, and policymakers access embodied carbon values of Indian construction materials for Life Cycle Assessment (LCA) studies.
      </p>
    </div>
  );
};

/** React component — User Home Intro. */
export default UserHomeIntro;
